<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NVZUTp/tc-custom/9781614752707.jpg?1699734108716" alt="This image is the cover for the book Mythology Abroad, Mythology"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mythology Abroad, Mythology
      </h1>
      <p class="bookDescription body article font2">
        <p>Keith Doyle, business major at Midwestern University, with an unofficial minor in mystical studies and magic overseen by his Little Folk friends, flies off to spend the summer on an educational tour of archaeological sites of the British Isles and Ireland with his best friend, Holl. They hope to locate signs of Holl’s long-lost relations as well as to help fulfill a traditional rite that will permit Holl to marry his beloved Maura. Keith’s reckless exploits attract the attention of not only magical folk who are far less friendly than the Little Folk back home, but human smugglers. The Master and Keith’s girlfriend Diane are forced to come to their aid. Can Keith keep from losing his college credits and Holl his one chance at happiness?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jody Lynn Nye
      </h2>
      
      <p class="authorDescription body article">Jody Lynn Nye lists her main career activity as 'spoiling cats.' When not engaged upon this worthy occupation, she writes fantasy and science fiction books and short stories. Before breaking away from gainful employment to write full time, Jody worked as a file clerk, bookkeeper at a small publishing house, freelance journalist, and photographer, accounting assistant and costume maker. For four years, she was on the technical operations staff of a local Chicago television station, ending as Technical Operations Manager. Since 1987 she has published 45 books and more than 110 short stories. Although she is best known as a collaborator with other notable authors such as Anne McCaffrey (the Ship Who series, the Dinosaur Planet series), Robert Asprin (Dragons and the Myth-Adventures), John Ringo (Clan of the Claw) and Piers Anthony, Jody has numerous solo books to her credit, mostly fantasy and science fiction with a humorous bent. Her newest book is Fortunes of the Imperium (Baen Books), the second of the Lord Thomas Kinago books, which she describes as "Jeeves and Wooster in space." Over the last twenty-five years or so, Jody has taught in numerous writing workshops and speaks at schools and libraries, and teaches the two-day writers' workshop at DragonCon in Atlanta. When not writing, she enjoys baking, calligraphy, travel, photography and, of course, reading. Jody lives in the northwest suburbs of Chicago with her husband, Bill Fawcett, and Jeremy, their cat. jodylynnnye.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Word Fire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f315ba6